<template>
  <div class="areaPage">
      <div class="title">{{$t('h5.DSX_index_slogn')}}</div>
      <div class="wrapper">
          <span class="bkvn" v-for="(item,index) in areaList" :key="index" @click="tpbnk(item.country)">
                <div class="picBox">
                    <img style="width:100%" :src="item.imgUrl" />
                </div>
                <div style="margin-top:5px">{{item.label}}</div>
            </span>
      </div>
      
  </div>
</template>

<script>
export default {
data(){
return{
    areaList:[{
        country:'TH',
        label:this.$t('h5.DSX_index_th'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/19eab6fe794e4afb9fa1926be6d69fd1.png'
    },{
        country:'MY',
        label:this.$t('h5.DSX_index_my'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/12ef3ca7a7504a46a94bf6cc9c90afdd.png'
    },{
        country:'PH',
        label:this.$t('h5.DSX_index_ph'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/33c5ac8214fe450fa3a9f79792d5cba7.png'
    },
    // {
    //     country:'TW',
    //     label:this.$t('h5.DSX_index_tw'),
    //     imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/f384543fc28841409f5a75346b4e9447.png'
    // },
    {
        country:'ID',
        label:this.$t('h5.DSX_index_id'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/245a7cf4081347628838b042479e8c3a.png'
    },{
        country:'VN',
        label:this.$t('h5.DSX_index_vn'),
        imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/36312c8bb5064d5c9e8d21eda8ea23e6.png'
    },
    // {
    //     country:'BZ',
    //     label:this.$t('h5.DSX_index_bz'),
    //     imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/c71468db1f744cf585a0161dbb2cfda7.png'
    // },{
    //     country:'CN',
    //     label:this.$t('h5.DSX_index_cn'),
    //     imgUrl:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/664e760fce604256a502794ffa85df71.jpg'
    // }
]
    
}
},
create(){

},
methods:{
 tpbnk(code){
     console.log(code)
     this.$router.push({
         path:'/mh5/pageOne',
         query:{
             country:code
         }
     })
 }
}
}

</script>
<style lang="scss" scoped>
.areaPage{
    background-color: #fff;
    margin:10px;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 10px;

    .wrapper{
        display: flex;
        width: 100%;
        justify-content: flex-start;
        flex-wrap: wrap;
       
    }

    .title{
        width: 100%;
        text-align: center;
        font-size: 15px;
        padding-bottom: 10px ;
    }



  

    .bkvn{
        width: 33%;
       
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        margin-bottom: 10px;
    }

    .picBox{
        width: 2rem;
        height: 2rem;
        overflow: hidden;
    }
    
}
</style>